import * as jsPDF from 'jspdf';
import * as html2canvas from "html2canvas";


import { Injectable, ElementRef, Renderer2 } from '@angular/core';

@Injectable()
export class PdfExporterService {

  constructor(private renderer: Renderer2) { }

  /**
   * Export an html section to pdf file.
   * @param container Container with the component that have a pdf template
   * @param fileName Name of exported file.
   * @param exportOptions options of exported file (measurements)
   */
  export(container: ElementRef, fileName: string, exportOptions: CanvasOptions = {xCoordinate: 22, yCoordinate: 10, width: 550, height: 1080}) {

    const content = container.nativeElement;

    html2canvas(content, {scale:3}).then((canvas) => {
      const jpegUrl = canvas.toDataURL("image/jpeg");
      const doc = new jsPDF("p", "pt", "a4");            
      doc.addImage(jpegUrl, 'JPEG',
                   exportOptions.xCoordinate,
                   exportOptions.yCoordinate,
                   exportOptions.width, 
                   exportOptions.height);
      doc.save(fileName);
  });

  }

}

interface CanvasOptions {
  xCoordinate: number;
  yCoordinate: number;
  width: number;
  height: number;
}



// WEBPACK FOOTER //
// ./src/app/cliente-sae/service/pdf-exporter.service.ts